var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nps-rating d-flex align-items-center justify-content-center",class:{'bg-success': _vm.promoter, 'bg-warning': _vm.neutral, 'bg-danger': _vm.detractor}},[_c('div',[_vm._v(_vm._s(_vm.rating))])])}
var staticRenderFns = []

export { render, staticRenderFns }